/* src/app/common/components/item-selection/item-selection.component.scss */
:host {
  display: block;
}
ion-content {
  --offset-bottom: -57px !important;
}
/*# sourceMappingURL=item-selection.component.css.map */
